import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const FIELD_TYPES = ['string', 'number', 'text', 'select', 'select-multi', 'date'] as const;
const FIELD_PROPERTIES = ['title', 'i18nKey', 'type', 'selectValues'] as const;

const CodeBlock = ({ code }: { code: string }) => (
    <pre className="mb-0 small bg-light p-2 rounded border overflow-auto">{code}</pre>
);

const BusinessModeFormHelp = () => {
    const { t } = useTranslation(['Settings']);

    return (
        <div className="overflow-auto pe-1" style={{ maxHeight: 'calc(100vh - 230px)' }}>
            <p className="text-muted fs-12 mb-3">{t('businessMode.editor.help.intro')}</p>

            <h6 className="mb-2">{t('businessMode.editor.help.structureTitle')}</h6>
            <p className="fs-12 mb-2">{t('businessMode.editor.help.structureDescription')}</p>
            <CodeBlock code={t('businessMode.editor.help.structureExample')} />

            <h6 className="mb-2 mt-4">{t('businessMode.editor.help.propertiesTitle')}</h6>
            <Table responsive className="table-sm align-middle fs-12 mb-0" style={{ minWidth: '420px' }}>
                <thead>
                    <tr className="bg-light">
                        <th style={{ width: '120px' }}>{t('businessMode.editor.help.propertiesTable.property')}</th>
                        <th style={{ width: '100px' }}>{t('businessMode.editor.help.propertiesTable.required')}</th>
                        <th>{t('businessMode.editor.help.propertiesTable.description')}</th>
                    </tr>
                </thead>
                <tbody>
                    {FIELD_PROPERTIES.map((property) => (
                        <tr key={property}>
                            <td>
                                <code>{property}</code>
                            </td>
                            <td>{t(`businessMode.editor.help.properties.${property}.required`)}</td>
                            <td className="text-break">{t(`businessMode.editor.help.properties.${property}.description`)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <h6 className="mb-2 mt-4">{t('businessMode.editor.help.typesTitle')}</h6>
            <p className="fs-12 text-muted mb-3">{t('businessMode.editor.help.typesHint')}</p>
            {FIELD_TYPES.map((type) => (
                <div key={type} className="mb-3">
                    <div className="mb-1">
                        <code>{type}</code>
                        <span className="ms-2 fs-12">{t(`businessMode.editor.help.types.${type}.description`)}</span>
                    </div>
                    <CodeBlock code={t(`businessMode.editor.help.types.${type}.example`)} />
                </div>
            ))}

            <h6 className="mb-2 mt-4">{t('businessMode.editor.help.fullExampleTitle')}</h6>
            <p className="fs-12 mb-2">{t('businessMode.editor.help.fullExampleDescription')}</p>
            <CodeBlock code={t('businessMode.editor.help.fullExample')} />

            <p className="text-muted fs-12 mt-3 mb-0">{t('businessMode.editor.help.notes')}</p>
        </div>
    );
};

export default BusinessModeFormHelp;
